import { render, staticRenderFns } from "./Category_productDirectory.vue?vue&type=template&id=4865dbed&scoped=true"
import script from "./Category_productDirectory.vue?vue&type=script&lang=js"
export * from "./Category_productDirectory.vue?vue&type=script&lang=js"
import style0 from "./Category_productDirectory.vue?vue&type=style&index=0&id=4865dbed&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4865dbed",
  null
  
)

export default component.exports